import { RestChatService } from '@repo/network'
import { useMutation } from '@tanstack/react-query'
import { ComponentOrderMessageVO } from '@repo/types/src/types/ComponentOrderMessageVO'

export const useSendOrderMessage = () => {
  const { mutate: handleSubmit, isPending: isSubmitting } = useMutation({
    mutationKey: ['sendOrder'],
    mutationFn: async (orderMessage: ComponentOrderMessageVO) => {
      await RestChatService.sendOrder(orderMessage)
    }
  })

  return {
    handleSubmit,
    isSubmitting
  }
}
